import React, { useRef, memo, useLayoutEffect } from 'react';
import usePrevious from '../../../hooks/usePrevious';

export interface SingleOTPInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    focus?: boolean;
    istouched?: boolean;
}

const SingleInput = (props: SingleOTPInputProps) => {
    const { focus, istouched, autoFocus, ...rest } = props;
    const inputRef = useRef<HTMLInputElement>(null);
    const prevFocus = usePrevious(!!focus);

    useLayoutEffect(() => {
        if (istouched) {
            if (inputRef.current) {
                if (focus) {
                    inputRef.current.focus();
                }
                if (focus && focus !== prevFocus) {
                    inputRef.current.focus();
                    inputRef.current.select();
                }
            }
        }
    }, [autoFocus, focus, istouched, prevFocus]);

    return <input type="tel" pattern="[0-9]*" ref={inputRef} name="masterCode" {...rest} />;
};

const SingleOtpInput = memo(SingleInput);

export default SingleOtpInput;
